/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'confluence-table-tree.column.contributors': 'Osallistujat',
  'confluence-table-tree.column.last-modified': 'Viimeksi muokattu',
  'confluence-table-tree.column.title': 'Nimi',
  'confluence-table-tree.could-not-load': 'Ei voitu ladata',
  'confluence-table-tree.could-not-load-contributors': 'Osallistujia ei voitu ladata',
  'confluence-table-tree.create-child-page': 'Luo alasivu',
  'confluence-table-tree.create-page': 'Luo sivu',
  'confluence-table-tree.default.page.title': 'Nimeämätön',
  'confluence-table-tree.default.show-all-pages-button.label': 'Näytä enemmän sivuja',
  'confluence-table-tree.draft.lozenge': 'LUONNOS',
  'confluence-table-tree.draft.tooltip': 'Luonnokset näkyvät vain sinulle.',
  'confluence-table-tree.drafts-toggle.label': 'Näytä luonnokset',
  'confluence-table-tree.edit': 'Muokkaa',
  'confluence-table-tree.edit-in-confluence': 'Muokkaa Confluencessa',
  'confluence-table-tree.empty.description':
    'Täytä tämä työtila luomalla kokousmuistioita, tuotevaatimuksia, päätöksiä tai muuta sisältöä.',
  'confluence-table-tree.empty.title': 'Täällä on pelkkää potentiaalia',
  'confluence-table-tree.error.description': 'Näitä sivuja ei voi näyttää. Yritä myöhemmin uudelleen.',
  'confluence-table-tree.error.row': 'Sivujen lataus ei onnistu.',
  'confluence-table-tree.error.title': 'Nyt kävi nolosti.',
  'confluence-table-tree.friendly-when-created': 'Luotu',
  'confluence-table-tree.friendly-when-updated': 'Päivitetty',
  'confluence-table-tree.share.copied': 'Kopioitu leikepöydälle',
  'confluence-table-tree.share.copy-button': 'Kopioi',
  'confluence-table-tree.share.subtitle': 'Jaa tämä linkki',
  'confluence-table-tree.share.title': 'Jaa sivu',
  'confluence-table-tree.share.tooltip': 'Jaa',
  'confluence-table-tree.view-profile': 'Näytä profiili',
};
